import { render, staticRenderFns } from "./HeaderVs.vue?vue&type=template&id=5fca816e&scoped=true&"
import script from "./HeaderVs.vue?vue&type=script&lang=ts&"
export * from "./HeaderVs.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderVs.vue?vue&type=style&index=0&id=5fca816e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca816e",
  null
  
)

export default component.exports